import { createMultiStyleConfigHelpers as u, defineStyle as n } from "@chakra-ui/react";
import { ThemeColorVariable as e, ThemeBorderVariable as a, ThemeSpaceVariable as r, ThemeRadiusVariable as o, ThemeFontSizeVariable as c } from "../../theme-types.js";
import { accordionAnatomy as b } from "../../../packages/casper-ui-library/node_modules/@chakra-ui/anatomy/dist/esm/components.js";
const { definePartsStyle: t, defineMultiStyleConfig: s } = u(b.keys), d = n({
  width: "100%"
}), i = n({
  display: "flex",
  width: "100%",
  fontSize: c.Large,
  fontWeight: "500",
  py: r.Small,
  px: r.Medium,
  "@media(hover: hover)": {
    _hover: {
      background: e.SurfaceDisabled
    }
  },
  svg: {
    pointerEvents: "none"
  }
}), l = n({
  width: "100%",
  padding: r.Medium,
  color: e.OnSurface
}), m = t({
  button: {
    color: e.OnSurface,
    background: e.Surface,
    borderRadius: o.Medium,
    justifyContent: "space-between",
    _expanded: {
      borderBottom: a.XSmall,
      borderColor: e.OnSurfaceBorder,
      borderBottomRadius: o.None
    },
    ...i
  },
  container: {
    border: "none"
  },
  root: {
    background: e.Surface,
    borderRadius: o.Medium,
    border: a.XSmall,
    borderColor: e.OnSurfaceBorder,
    ...d
  },
  panel: {
    ...l
  }
}), f = t({
  button: {
    ...i,
    color: e.OnBackground,
    flexDirection: "row-reverse",
    justifyContent: "flex-end",
    gap: r.XSmall,
    "@media(hover: hover)": {
      _hover: {
        background: e.SurfaceDisabled,
        borderRadius: o.Medium
      }
    },
    _expanded: {
      borderBottomRadius: o.None
    }
  },
  container: {
    border: "none"
  },
  root: {
    background: "transparent",
    // Root has no expanded state on its own, we identify the state via the button
    ':has(button[aria-expanded="true"])': {
      borderRadius: o.Medium,
      border: a.XSmall,
      borderColor: e.OnSurfaceBorder
    },
    ...d
  },
  panel: {
    pt: 0,
    px: r.Medium,
    pb: r.Medium,
    color: e.OnBackground,
    width: "100%"
  }
}), S = t({
  button: {
    color: e.OnSurface,
    background: "transparent",
    justifyContent: "space-between",
    ...i
  },
  container: {
    borderTopWidth: 0,
    borderBottom: a.XSmall,
    borderBottomColor: e.OnSurfaceBorder,
    "&:last-child": {
      borderBottom: "none"
    }
  },
  root: {
    background: e.Surface,
    border: "none",
    ...d
  },
  panel: {
    ...l
  }
}), B = s({
  variants: {
    border: m,
    noBorder: f,
    list: S
  },
  defaultProps: {
    variant: "border"
  }
});
export {
  B as accordionConfig
};
